:host {
  .av-notification-manager {
    display: flex;
    flex-direction: column;
    z-index: 100500;
    position: absolute;

    &.av-notification-manager-offset {
      bottom: calc($container-height * 2 + 10px);
    }
  }

  .av-notification-manager-left {
    left: 0;
  }

  .av-notification-manager-right {
    right: 0;
  }

  .av-notification-manager-center {
    right: 50%;
    transform: translateX(50%);
  }

  .av-notification-manager-bottom {
    bottom: $container-height;
    av-notification {
      margin-bottom: 10px;
    }
  }

  .av-notification-manager-top {
    top: $container-height;
    av-notification {
      margin-top: 10px;
    }
  }
  .av-notification-manager-voice {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
  }
}
